import React from 'react';
import PropTypes from 'prop-types';
import { clearPhone } from '../../utils';

const item = require('b_').with('phone-list');

const extractPhoneNumber = n => clearPhone(n);

export const PhoneListItem = ({ phone }) => (
    <a href={`tel:${extractPhoneNumber(phone)}`}>
        <div className={item('item')}>{phone}</div>
    </a>
);

PhoneListItem.propTypes = { phone: PropTypes.string.isRequired };
